/**
 * The Slack channel an alert posts to, as the reader pastes it.
 *
 * Pure, and React-free. The endpoint asks Slack about the channel before it
 * saves, so this check only tells the reader early that what they pasted is
 * not a channel at all.
 */

/** A public (`C`) or private (`G`) channel id, as Slack writes it. The endpoint's own pattern. */
const CHANNEL_ID = /^[CG][A-Z0-9]{8,}$/

/** A link Slack's Copy link gives for a channel or a message in it. */
const CHANNEL_LINK =
  /^https:\/\/[a-z0-9-]+\.slack\.com\/archives\/([CG][A-Z0-9]{8,})(?:[/?#]|$)/

/** The channel id, or what is wrong with what the reader pasted. */
export type SlackChannelRead =
  { ok: true; id: string } | { ok: false; problem: string }

/**
 * Read the channel the reader pasted: its id, or its link.
 *
 * @param text - What the field holds.
 * @returns The channel id, or the problem.
 */
export function readSlackChannel(text: string): SlackChannelRead {
  const value = text.trim()
  if (value === '') {
    return { ok: false, problem: 'Paste the channel’s link or its ID.' }
  }
  const id = CHANNEL_ID.test(value) ? value : CHANNEL_LINK.exec(value)?.[1]

  return id
    ? { ok: true, id }
    : {
        ok: false,
        problem: `${value} is not a channel link or a channel ID, such as C0123ABCD.`
      }
}
